<template>
  <div>
    Ciro
    <ul>
      <li>
        - Mekanik Ciro
      </li>
      <li>
        ----- Marka Bazlı Ciro
      </li>
      <li>
        ----- Geçmiş dönem ile değişim oranı %
      </li>
      <li>
        - Kaporta Ciro
      </li>
      <li>
        ----- Marka Bazlı Ciro
      </li>
      <li>
        ----- Geçmiş dönem ile değişim oranı %
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'Payment',
}
</script>
